export function normalizeAuthorName(raw: string | null | undefined): string {
  const value = String(raw || '').trim()
  if (!value) return 'Usuário'

  if (value.includes('@')) {
    const [before] = value.split('@')
    const cleaned = before.replace(/[._]+/g, ' ')
    const parts = cleaned.split(/\s+/).filter(Boolean)
    if (!parts.length) return value
    return parts
      .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : ''))
      .filter(Boolean)
      .join(' ')
  }

  return value
}

